export default "__VITE_ASSET__$PseplJ0WqW_8kNjnxhaKw__"